//  helper functions
import hexToRgb from "./hexToRgb";

export default function rgba(color: string, opacity: number): string {
  return `rgba(${hexToRgb(color)}, ${opacity})`;
}
